import * as React from "react";
import { Icon } from "sb-resp-ui";

export class GameIcon extends React.Component<{ i?: string }, {}> {

    render() {
        return (
            <div className="rj-sports-multiview__event-game-icon">
                {this.props.i && <Icon i={this.props.i}/>}
            </div>
        )
    }
}